import { useState } from 'react';

import InfoRounded from '@mui/icons-material/InfoRounded';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

import useResponsive from '~/hooks/useResponsive';

type MuiTooltipProps = Omit<TooltipProps, 'children'>;

type CommonTooltipProps = {
  'data-testid'?: string;
  children?: React.ReactElement<any, any>;
} & MuiTooltipProps;

const mobilePopperSx = {
  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
    {
      marginTop: 1,
    },
};

const CommonTooltip = ({
  'data-testid': testId = 'tooltip-btn',
  children = (
    <IconButton>
      <InfoRounded />
    </IconButton>
  ),
  ...props
}: CommonTooltipProps) => {
  const [open, setOpen] = useState(false);
  const { isMobile } = useResponsive();

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return isMobile() ? (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          arrow
          open={open}
          placement="top-start"
          disableHoverListener
          disableFocusListener
          disableTouchListener
          onClose={handleTooltipClose}
          slotProps={{
            popper: {
              disablePortal: true,
              sx: mobilePopperSx,
            },
          }}
          data-testid={testId}
          {...props}
        >
          <Stack onClick={handleTooltipOpen} sx={{ p: 0 }}>
            {children}
          </Stack>
        </Tooltip>
      </div>
    </ClickAwayListener>
  ) : (
    <Tooltip data-testid={testId} {...props}>
      {children}
    </Tooltip>
  );
};

export default CommonTooltip;
